module.exports = __webpack_public_path__ + "img/baojian.50a038db.png";